import React, { ComponentProps } from "react";
import { useWindowDimensions } from "react-native";
import {
  BottomSheet,
  BottomSheetHeader,
  BottomSheetContent,
  BottomSheetFooter,
} from "../BottomSheet/BottomSheet";
import { Modal, ModalHeader, ModalContent, ModalFooter } from "../Modal/Modal";
import { TABLET_BREAKPOINT } from "@src/packages/utils/common";

export function DynamicModal(
  props: ComponentProps<typeof Modal | typeof BottomSheet>,
) {
  const { width } = useWindowDimensions();
  const isLargeViewport = width >= TABLET_BREAKPOINT;

  if (isLargeViewport) {
    return <Modal {...(props as ComponentProps<typeof Modal>)} />;
  }

  return <BottomSheet {...props} />;
}

export function DynamicModalHeader(
  props: ComponentProps<typeof ModalHeader | typeof BottomSheetHeader>,
) {
  const { width } = useWindowDimensions();
  const isLargeViewport = width >= TABLET_BREAKPOINT;

  if (isLargeViewport) {
    return <ModalHeader {...props} />;
  }

  return <BottomSheetHeader {...props} />;
}

export function DynamicModalContent(
  props: ComponentProps<typeof ModalContent | typeof BottomSheetContent>,
) {
  const { width } = useWindowDimensions();
  const isLargeViewport = width >= TABLET_BREAKPOINT;

  if (isLargeViewport) {
    return <ModalContent {...props} />;
  }

  return <BottomSheetContent {...props} />;
}

export function DynamicModalFooter(
  props: ComponentProps<typeof ModalContent | typeof BottomSheetContent>,
) {
  const { width } = useWindowDimensions();
  const isLargeViewport = width >= TABLET_BREAKPOINT;

  if (isLargeViewport) {
    return <ModalFooter {...props} />;
  }

  return <BottomSheetFooter {...props} />;
}
